export default {
  svgPath: `
    <path d="M10.5 14a4 4 0 100-8 4 4 0 000 8z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 10c0 5.523-4.477 10-10 10S.5 15.523.5 10s4.477-10 10-10 10 4.477 10 10zm-2 0a8 8 0 11-16 0 8 8 0 0116 0z"/>
  `,
  title: 'Circle With Fill',
  viewBox: '0 0 21 20',
};
